import {ColumnDef} from '@tanstack/react-table'
import {AgingReportData} from '../API/AgingReport'
import {formatNumber} from '../../../../_metronic/helpers'
import {KTIcon} from '../../../../_metronic/helpers'
import {Link} from 'react-router-dom'
const getAgingReportColumns = (activeTab: string): ColumnDef<AgingReportData>[] => [
  {
    header: () => (
      <div
        className='px-3 min-w-100px col-lg-1 text-center'
        style={{fontSize: '12px', fontWeight: '700', color: '#343541'}}
      >
        Parent Ledger
      </div>
    ),
    accessorKey: 'parentLedger',

    cell: (info) => <div className='text-center'>{(info.getValue() as string) ?? '-'}</div>,
  },
  {
    header: () => (
      <div
        className='col-lg-1 min-w-100px text-center'
        style={{fontSize: '12px', fontWeight: '700', color: '#343541'}}
      >
        Sub Ledger
      </div>
    ),
    accessorKey: 'subLedger',

    cell: (info) => <div className='text-center'>{(info.getValue() as string) ?? '-'}</div>,
  },
  {
    header: () => (
      <div
        className='col-lg-3 min-w-150px text-center '
        style={{fontSize: '12px', fontWeight: '700', color: '#343541'}}
      >
        Total Invoice Amount
      </div>
    ),
    accessorKey: 'totalInvoiceAmount',
    cell: (info) => (
      <div className='text-end'>
        {(info.getValue() as string) ? formatNumber(info.getValue() as string) : '-'}
      </div>
    ),
  },
  {
    header: () => (
      <div
        style={{fontSize: '12px', fontWeight: '700', color: '#343541'}}
        className='col-lg-2 min-w-125px text-center'
      >
        Set Off Amount
      </div>
    ),
    accessorKey: 'setOffAmount',
    cell: (info) => (
      <div className='text-end'>
        {(info.getValue() as string) ? formatNumber(info.getValue() as string) : '-'}{' '}
      </div>
    ),
  },
  {
    header: () => (
      <div
        style={{fontSize: '12px', fontWeight: '700', color: '#343541'}}
        className='col-lg-2 min-w-125px text-center'
      >
        Pending Invoices
      </div>
    ),
    accessorKey: 'pendingInvoices',
    cell: (info) => (
      <div className='text-end'>
        {(info.getValue() as string) ? formatNumber(info.getValue() as string) : '-'}{' '}
      </div>
    ),
  },
  {
    header: () => (
      <div
        style={{fontSize: '12px', fontWeight: '700', color: '#343541'}}
        className='col-lg-2 min-w-125px text-center'
      >
        Total Outstanding
      </div>
    ),
    accessorKey: 'totalOutstanding',
    cell: (info) => (
      <div className='text-end'>
        {(info.getValue() as string) ? formatNumber(info.getValue() as string) : '-'}{' '}
      </div>
    ),
  },

  {
    header: () => (
      <div
        style={{fontSize: '12px', fontWeight: '700', color: '#343541'}}
        className='col-lg-2 min-w-125px text-center'
      >
        0-15 Days
      </div>
    ),
    accessorKey: '0-15 days',
    cell: (info) => (
      <div className='text-end'>
        {(info.getValue() as string) ? formatNumber(info.getValue() as string) : '-'}{' '}
      </div>
    ),
  },
  {
    header: () => (
      <div
        style={{fontSize: '12px', fontWeight: '700', color: '#343541'}}
        className='col-lg-2 min-w-125px text-center'
      >
        16-30 Days
      </div>
    ),
    accessorKey: '16-30 days',
    cell: (info) => (
      <div className='text-end'>
        {(info.getValue() as string) ? formatNumber(info.getValue() as string) : '-'}{' '}
      </div>
    ),
  },
  {
    header: () => (
      <div
        style={{fontSize: '12px', fontWeight: '700', color: '#343541'}}
        className='col-lg-2 min-w-125px text-center'
      >
        31-60 Days
      </div>
    ),
    accessorKey: '31-60 days',
    cell: (info) => (
      <div className='text-end'>
        {(info.getValue() as string) ? formatNumber(info.getValue() as string) : '-'}{' '}
      </div>
    ),
  },
  {
    header: () => (
      <div
        style={{fontSize: '12px', fontWeight: '700', color: '#343541'}}
        className='col-lg-2 min-w-125px text-center'
      >
        61-90 Days
      </div>
    ),
    accessorKey: '61-90 days',
    cell: (info) => (
      <div className='text-end'>
        {(info.getValue() as string) ? formatNumber(info.getValue() as string) : '-'}{' '}
      </div>
    ),
  },
  {
    header: () => (
      <div
        style={{fontSize: '12px', fontWeight: '700', color: '#343541'}}
        className='col-lg-2 min-w-125px text-center'
      >
        91-180 Days
      </div>
    ),
    accessorKey: '91-180 days',
    cell: (info) => (
      <div className='text-end'>
        {(info.getValue() as string) ? formatNumber(info.getValue() as string) : '-'}{' '}
      </div>
    ),
  },
  {
    header: () => (
      <div
        style={{fontSize: '12px', fontWeight: '700', color: '#343541'}}
        className='col-lg-2 min-w-125px text-center'
      >
        {'>180 Days'}
      </div>
    ),
    accessorKey: '>180 days',
    cell: (info) => (
      <div className='text-end'>
        {(info.getValue() as string) ? formatNumber(info.getValue() as string) : '-'}{' '}
      </div>
    ),
  },
  {
    header: () => (
      <div
        style={{fontSize: '12px', fontWeight: '700', color: '#343541'}}
        className='col-lg-2 min-w-125px text-center'
      >
        Advances
      </div>
    ),
    accessorKey: 'advances',
    cell: (info) => (
      <div className='text-end'>
        {(info.getValue() as string) ? formatNumber(info.getValue() as string) : '-'}{' '}
      </div>
    ),
  },
  {
    header: () => (
      <div
        style={{fontSize: '12px', fontWeight: '700', color: '#343541'}}
        className='col-lg-2 min-w-125px text-center'
      >
        NO REFERENCE
      </div>
    ),
    accessorKey: 'noReference',
    cell: (info) => (
      <div className='text-end'>
        {(info.getValue() as string) ? formatNumber(info.getValue() as string) : '-'}
      </div>
    ),
  },
  {
    header: () => (
      <div
        style={{fontSize: '12px', fontWeight: '700', color: '#343541'}}
        className='col-lg-1 min-w-100px text-center'
      >
        Actions
      </div>
    ),
    accessorKey: 'ledgerId',
    cell: (info) => (
      <div className='text-center'>
        <Link
          data-bs-toggle='tooltip'
          data-bs-trigger='hover'
          data-bs-dismiss-='click'
          title='View Transactions'
          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
          to={`/transactions/trial-balance/ledger?ledgerId=${info.getValue()}`}
        >
          <KTIcon iconName='arrow-right' className='fs-2' />
        </Link>
      </div>
    ),
  },
]

export {getAgingReportColumns}
